/* Native scrolling retains server-rendered geometry and works without JS. */
(() => {
  if (customElements.get('fh-product-rail')) return;
  customElements.define('fh-product-rail', class extends HTMLElement {
    connectedCallback() {
      if (!this.hasAttribute('data-scroll') || this.dispose) return;
      const track=this.querySelector('.fh-product-rail__track'),prev=this.querySelector('[data-rail-prev]'),next=this.querySelector('[data-rail-next]');
      if (!track || !prev || !next) return;
      let frame=0;
      const update=()=>{frame=0;const max=Math.max(0,track.scrollWidth-track.clientWidth),position=Math.abs(track.scrollLeft);prev.disabled=position<2;next.disabled=position>=max-2;};
      const schedule=()=>{if(!frame)frame=requestAnimationFrame(update);};
      const move=event=>{const direction=(event.currentTarget===prev?-1:1)*(getComputedStyle(track).direction==='rtl'?-1:1);track.scrollBy({left:direction*track.clientWidth,behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'instant':'smooth'});};
      prev.addEventListener('click',move);next.addEventListener('click',move);track.addEventListener('scroll',schedule,{passive:true});
      const observer=new ResizeObserver(schedule);observer.observe(track);update();
      this.dispose=()=>{cancelAnimationFrame(frame);observer.disconnect();prev.removeEventListener('click',move);next.removeEventListener('click',move);track.removeEventListener('scroll',schedule);};
    }
    disconnectedCallback(){this.dispose?.();this.dispose=null;}
  });
})();
